import { Outlet } from 'react-router-dom'

export function ProfileSettingsShell() {
  return <Outlet />
}
